import React from "react"
import styles from "./styles.scss"
import FieldWrapper from "components/FieldWrapper"
import { reduxForm } from "redux-form"
import { Button, TYPES } from "components/Button"

class Form extends React.Component {
  render() {
    return (
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <h2>Kom i kontakt med oss</h2>
          <p>
            Har du frågor eller vill annonsera på Fixarfolket.se? Kom i
            kontakt med oss via mail till{" "}
            <strong>info@fixarfolket.se</strong>. Vi återkommer så snabbt
            vi kan.
          </p>

          {/*
          <form onSubmit={this.props.handleSubmit}>
            <FieldWrapper
              label="Företagsnamn"
              placeholder="Företagsnamn"
              name="companyName"
              component="input"
              type="text"
              className={styles.companyNameField}
            />
            <div className={styles.halfInputFields}>
              <FieldWrapper
                label="Ditt namn"
                placeholder="Förnamn Efternamn"
                name="name"
                component="input"
                type="text"
                className={styles.halvField}
              />
              <FieldWrapper
                label="E-postadress"
                placeholder="exempel@mail.se"
                name="email"
                component="input"
                type="text"
                className={styles.halvField}
              />
              
            </div>
            <FieldWrapper
                label="Meddelande"
                placeholder="Ert meddelande"
                name="message"
                component="textarea"
                type="text"
                className={styles.messageInput}
              />
            <Button buttonType={TYPES.SUCCESS}>Bli kontaktad</Button>
          </form>
          */}
        </div>
      </div>
    )
  }
}

Form = reduxForm({
  form: "contactForm",
})(Form)

export default Form



// WEBPACK FOOTER //
// src/pages/Contact/Form/index.jsx